var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactUsEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#3ED400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_299_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 12.1875H26.8125C27.028 12.1875 27.2347 12.2731 27.387 12.4255C27.5394 12.5778 27.625 12.7845 27.625 13V26C27.625 26.2155 27.5394 26.4222 27.387 26.5745C27.2347 26.7269 27.028 26.8125 26.8125 26.8125H12.1875C11.972 26.8125 11.7653 26.7269 11.613 26.5745C11.4606 26.4222 11.375 26.2155 11.375 26V13C11.375 12.7845 11.4606 12.5778 11.613 12.4255C11.7653 12.2731 11.972 12.1875 12.1875 12.1875V12.1875ZM19.5488 19.2424L14.339 14.8184L13.2868 16.0566L19.5593 21.3826L25.7189 16.0526L24.6561 14.8232L19.5496 19.2424H19.5488Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 19.5,
    fill: "white",
    transform: "translate(9.75 9.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsEmail);
export default __webpack_public_path__ + "static/media/ContactUsEmail.20c1da860671fa181ee4c9ef45f8eabd.svg";
export { ForwardRef as ReactComponent };